import {ProviderModel} from './ProviderModel';
import {RegionModel} from './RegionModel';
import {LocalCustomerModel} from './LocalCustomerModel';
import {ContractTypeModel} from './ContractTypeModel';
import {CurrencyModel} from './CurrencyModel';
import {ChargingMethodologyModel} from './ChargingMethodologyModel';
import {ServiceVariantModel} from './ServiceVariantModel';

export class TransformationModel {
  provider: ProviderModel;
  region: RegionModel;
  localCustomer: LocalCustomerModel;
  contractType: ContractTypeModel;
  serviceVariant: ServiceVariantModel;
  currency: CurrencyModel;
  chargingMethodology: ChargingMethodologyModel;
  milestoneNumber: number;
  amount: number;
  perInstallment: number;
  totalCost: number;
  region1: RegionModel;
  perCostRegion1: number;
  region2: RegionModel;
  perCostRegion2: number;


  constructor(provider?: ProviderModel, region?: RegionModel, localCustomer?: LocalCustomerModel, contractType?: ContractTypeModel,
              serviceVariant?: ServiceVariantModel, currency?: CurrencyModel, chargingMethodology?: ChargingMethodologyModel,
              milestoneNumber?: number, amount?: number, perInstallment?: number, totalCost?: number,
              region1?: RegionModel, perCostRegion1?: number, region2?: RegionModel, perCostRegion2?: number) {
    this.provider = provider;
    this.region = region;
    this.localCustomer = localCustomer;
    this.contractType = contractType;
    this.serviceVariant = serviceVariant;
    this.currency = currency;
    this.chargingMethodology = chargingMethodology;
    this.milestoneNumber = milestoneNumber;
    this.amount = amount;
    this.perInstallment = perInstallment;
    this.totalCost = totalCost;
    this.region1 = region1;
    this.perCostRegion1 = perCostRegion1;
    this.region2 = region2;
    this.perCostRegion2 = perCostRegion2;
  }
}
